import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventResponse} from '../../../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../../../@shared/services/events-service';
import {_AQH_EVE_5} from '../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-update-event-image',
  standalone: false,
  templateUrl: './update-event-image.html',
  styleUrl: './update-event-image.css'
})
export class UpdateEventImage {
  @Input() event: EventResponse
  @Input() imageType: 'header' | 'logo' = 'logo';

  selectedFile: File | null = null;
  uploading: boolean = false;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal) {
  }

  get title(): string {
    return this.imageType === 'header' ? 'Update Header Image' : 'Update Event Image';
  }

  get currentImageUrl(): string | null {
    return this.imageType === 'header' ? (this.event.header_url ?? null) : (this.event.image_url ?? null);
  }

  get description(): string {
    return this.imageType === 'header'
      ? 'Upload a new header image for your event (recommended size: 1920x300)'
      : 'Upload a new profile image for your event (recommended size: 400x400)';
  }

  onSave() {
    if (!this.selectedFile) {
      return;
    }

    this.uploading = true;
    const payload: _AQH_EVE_5 = {
      event_id: this.event.event_id,
      image_type: this.imageType,
      image: this.selectedFile
    };

    this.eventsService.editEventFiles(payload).subscribe({
      next: () => {
        this.uploading = false;
        this.modal.close(true);
      },
      error: () => {
        this.uploading = false;
      }
    });
  }

  close() {
    this.modal.close();
  }
}
